import React from "react";
import { useLocation } from "react-router-dom";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import NewPasswordForm from "./components/NewPasswordForm";
import ResetPasswordForm from "./components/ResetPasswordForm";

const ForgotPasswordPage = () => {
  const location = useLocation();

  const { userName } = Object.fromEntries(new URLSearchParams(location.search));

  return (
    <AuthFlowLayout
      heading="Join BrandGen.io"
      description="Create account: to view your personalized dashboard, campaigns, and audiences."
    >
      {userName ? <NewPasswordForm userName={userName} /> : <ResetPasswordForm />}
    </AuthFlowLayout>
  );
};

export default ForgotPasswordPage;
